import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-measured-answer',
  templateUrl: './measured-answer.component.pug',
  styleUrls: ['./measured-answer.component.scss'],
  standalone: false
})
export class MeasuredAnswerComponent implements OnInit {
  @Input() options: any;
  constructor() { }

  ngOnInit(): void {
  }

}
